export default __webpack_public_path__ + "static/media/IC00062-time.20833b0e.svg";